import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "", full_name: "", workspace_name: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success(`Workspace berhasil dibuat! Selamat datang, ${form.workspace_name}.`);
      navigate("/app/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Gagal mendaftar");
    } finally {
      setLoading(false);
    }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FDFDFC]">
      <div className="hidden lg:flex relative overflow-hidden bg-slate-900">
        <div className="absolute inset-0 opacity-30" style={{ background: "radial-gradient(ellipse at 70% 20%, rgba(217,119,6,0.5), transparent 50%)" }} />
        <div className="relative h-full flex flex-col justify-between p-12 text-white w-full">
          <Link to="/" className="font-serif-display text-3xl">Nusa<span className="text-amber-500">.</span></Link>
          <div>
            <h2 className="font-serif-display text-5xl leading-tight">Mulai dalam<br /><span className="italic text-amber-400">5 menit.</span></h2>
            <p className="mt-6 text-slate-300 max-w-md">Buat workspace, undang tim, dan mulai catat transaksi bisnis nusantara Anda hari ini. Trial 14 hari, tanpa kartu kredit.</p>
          </div>
          <div className="text-sm text-slate-400">
            Sudah lebih dari 1.200+ bisnis Indonesia percaya pada Nusa.
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-md" data-testid="register-page">
          <div className="lg:hidden mb-8">
            <Link to="/" className="font-serif-display text-3xl text-slate-900">Nusa<span className="text-amber-600">.</span></Link>
          </div>
          <h1 className="font-serif-display text-4xl font-medium text-slate-900">Daftar Nusa</h1>
          <p className="mt-2 text-slate-600 text-sm">Trial 14 hari. Tanpa kartu kredit.</p>

          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="register-form">
            <div>
              <Label className="text-slate-700">Nama Lengkap</Label>
              <Input value={form.full_name} onChange={set("full_name")} required className="mt-1 h-11" data-testid="reg-name-input" />
            </div>
            <div>
              <Label className="text-slate-700">Nama Bisnis / Workspace</Label>
              <Input value={form.workspace_name} onChange={set("workspace_name")} required className="mt-1 h-11" placeholder="Contoh: Kopi Nusantara" data-testid="reg-workspace-input" />
            </div>
            <div>
              <Label className="text-slate-700">Email</Label>
              <Input type="email" value={form.email} onChange={set("email")} required className="mt-1 h-11" data-testid="reg-email-input" />
            </div>
            <div>
              <Label className="text-slate-700">Password</Label>
              <Input type="password" value={form.password} onChange={set("password")} required minLength={6} className="mt-1 h-11" data-testid="reg-password-input" />
              <div className="text-xs text-slate-500 mt-1">Minimal 6 karakter</div>
            </div>
            <Button type="submit" className="w-full h-11 bg-amber-600 hover:bg-amber-700 text-white rounded-md" disabled={loading} data-testid="register-submit-btn">
              {loading ? "Memproses..." : "Buat Workspace & Mulai Trial"}
            </Button>
          </form>
          <div className="text-sm text-center mt-6 text-slate-600">
            Sudah punya akun? <Link to="/login" className="text-amber-700 font-medium hover:underline" data-testid="login-link">Masuk</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
